import React, { Fragment } from 'react';
import pt from 'prop-types';
import Icon from 'components/icon';
import ButtonLink from 'components/button/link';
import Command from 'components/command';
import { classNames } from 'utils/index';
import './action.scss';

export default class Action extends React.PureComponent {
  static propTypes = {
    title: pt.string.isRequired,
    subtitle: pt.string,
    icon: pt.object,
    button: pt.object,
    actions: pt.array,
  };

  renderCommandAction(action) {
    const { title, command } = action;

    return (
      <div className="command-action">
        <div className="command-action-title">{title}</div>
        <Command command={command} />
      </div>
    );
  }

  renderAction = (action = this.props) => {
    const { title, subtitle, icon, button, command } = action;

    if (command) {
      return this.renderCommandAction(action);
    }

    return (
      <div className="action">
        {icon && <Icon className="action-icon" {...icon} />}
        <div className="action-body">
          <div className="action-title">{title}</div>
          <div className="action-subtitle">{subtitle}</div>
        </div>
        {button && (
          <ButtonLink
            size="sm"
            type="secondary"
            className={classNames(
              'action-button',
              `action-button-${button.align || 'center'}`,
            )}
            {...(button.onClick
              ? { onClick: this.props[button.onClick] }
              : button.isInternalLink
              ? { to: button.link }
              : { href: button.link, target: 'blank' })}
          >
            {button.action}
          </ButtonLink>
        )}
      </div>
    );
  };

  renderActions = () => {
    const { title, subtitle, actions } = this.props;

    return (
      <div className="action-multiple">
        <div className="action-multiple-title">{title}</div>
        <div className="action-multiple-subtitle">{subtitle}</div>
        {actions.map((action, i) => (
          <Fragment key={i}>{this.renderAction(action)}</Fragment>
        ))}
      </div>
    );
  };

  render() {
    const { actions } = this.props;
    const isMultipleActions = actions?.length > 0;

    return (
      <div className="action-container">
        {isMultipleActions ? this.renderActions() : this.renderAction()}
      </div>
    );
  }
}
